import { HStack, Text } from '@chakra-ui/react';
import { Dispatch, SetStateAction } from 'react';
import { Icon } from 'src/components/atoms/Icon';

type IProps = {
  onLoginClick: Dispatch<SetStateAction<boolean>>;
};

const DesktopLogin: React.FC<IProps> = (props: IProps) => (
  <HStack
    spacing={2}
    cursor="pointer"
    _hover={{ color: '#B3B6F7' }}
    onClick={(e) => props.onLoginClick(true)}
    display={{ base: 'none', lg: 'flex' }}>
    <Icon iconName="login" width={6} height={6} color={'transparent'} />
    <Text
      color="white"
      fontWeight="semibold"
      fontSize="16px"
      fontFamily="marketingPage"
      whiteSpace="nowrap">
      Log In
    </Text>
  </HStack>
);

export default DesktopLogin;
